import { render, staticRenderFns } from "./DashboardEnlace.vue?vue&type=template&id=d98c4c8c"
import script from "./DashboardEnlace.vue?vue&type=script&lang=js"
export * from "./DashboardEnlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports